(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prjct-drop"] && !Shopify.designMode) return;
  try {
    
// Each product owns its images, color, view, variant form and purchase dialog.
if (!customElements.get('prjct-shirt')) customElements.define('prjct-shirt', class extends HTMLElement {
  connectedCallback() {
    this.abort?.abort(); this.abort = new AbortController();
    const on = (el, name, fn, options = {}) => el?.addEventListener(name, fn, { ...options, signal: this.abort.signal });
    const q = s => this.querySelector(s), qa = s => [...this.querySelectorAll(s)];
    const images = JSON.parse(q('[data-images]').textContent);
    const figure = q('[data-figure]'), photo = q('.product-img'), lens = q('.lens-image');
    const dialog = q('.purchase-dialog'), variant = q('[data-variant]'), sizeChoices = qa('[data-size-choice]');
    let color = 'black', view = 'front', swipe = null, suppress = false, previewSize = null;
    const preview = q('.image-preview-dialog'), previewImage = q('[data-preview-image]');
    const normSize = value => {
      const s = String(value || '').trim().toLowerCase().replace(/\s+/g, '').replace(/-/g, '');
      if (s === 'xxl' || s === '2xlarge' || s === 'xxlarge') return '2xl';
      if (s === 'xlarge') return 'xl';
      if (s === 'large') return 'l';
      if (s === 'medium') return 'm';
      if (s === 'small') return 's';
      return s;
    };
    const syncSizeChoices = () => {
      const selected = variant?.selectedOptions[0];
      const current = selected ? normSize(selected.dataset.size) : previewSize;
      sizeChoices.forEach(button => {
        const value = button.dataset.sizeChoice;
        if (variant) {
          const match = [...variant.options].find(option => option.dataset.color === color && normSize(option.dataset.size) === value);
          button.disabled = !match || match.dataset.available !== 'true';
        } else {
          button.disabled = false;
        }
        button.setAttribute('aria-pressed', String(current === value));
      });
    };
    const render = () => {
      const src = images[color]?.[view];
      photo.removeAttribute('srcset'); photo.src = src || ''; photo.alt = `${this.dataset.title} — ${color}, ${view}`;
      q('[data-photo-error]').hidden = !!src;
      if (lens) { lens.removeAttribute('srcset'); lens.src = images[color]?.back || ''; }
      q('.shirt-tag').hidden = true;
      figure.classList.remove('lens-active');
      figure.setAttribute('aria-label', `Enlarge ${this.dataset.title} image`);
      figure.setAttribute('aria-haspopup','dialog');
      previewImage.src = src || ''; previewImage.alt = photo.alt;
      qa('[data-view]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.view === view)));
      qa('button[data-color]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.color === color)));
      qa('[data-color-name]').forEach(el => el.textContent = color);
      q('[data-dialog-image]').src = images[color]?.back || '';
      if(q('[data-demo-color]')) q('[data-demo-color]').value = color;
      this.selection = { color, view };
    };
    const syncVariant = () => {
      const selected = variant?.selectedOptions[0]; if (!selected) return;
      const available = selected.dataset.available === 'true';
      q('[data-add]').disabled = !available;
      q('[data-add]').textContent = available ? q('[data-add]').dataset.addLabel : q('[data-add]').dataset.soldLabel;
      qa('[data-price]').forEach(el => el.textContent = selected.dataset.price);
      if (selected.dataset.color) color = selected.dataset.color;
      previewSize = normSize(selected.dataset.size);
      syncSizeChoices();
      render();
    };
    const setColor = value => {
      color = value;
      if (variant) {
        const oldSize = normSize(variant.selectedOptions[0]?.dataset.size);
        const choices = [...variant.options].filter(o => o.dataset.color === value);
        const match = choices.find(o => normSize(o.dataset.size) === oldSize) || choices.find(o => o.dataset.available === 'true') || choices[0];
        if (match) { variant.value = match.value; syncVariant(); }
        else { q('[data-add]').disabled = true; q('[data-add]').textContent = q('[data-add]').dataset.soldLabel; }
      }
      syncSizeChoices();
      render();
    };
    const setSize = value => {
      previewSize = value;
      if (variant) {
        const match = [...variant.options].find(option => option.dataset.color === color && normSize(option.dataset.size) === value);
        if (match) {
          variant.value = match.value;
          syncVariant();
          return;
        }
      }
      syncSizeChoices();
    };
    qa('[data-view]').forEach(b => on(b,'click',()=>{view=b.dataset.view;render();}));
    qa('button[data-color]').forEach(b => on(b,'click',()=>setColor(b.dataset.color)));
    sizeChoices.forEach(b => on(b,'click',()=>setSize(b.dataset.sizeChoice)));
    on(q('[data-demo-color]'),'change',e=>setColor(e.target.value));
    on(variant,'change',syncVariant);
    on(figure,'click',()=>{if(suppress){suppress=false;return;}render();preview.showModal();});
    on(figure,'keydown',e=>{if(!['Enter',' '].includes(e.key))return;e.preventDefault();render();preview.showModal();});
    on(preview,'keydown',e=>{if(!['ArrowLeft','ArrowRight'].includes(e.key))return;e.preventDefault();view=view==='front'?'back':'front';render();});
    on(preview,'close',()=>figure.focus({preventScroll:true}));
    on(figure,'pointerdown',e=>{suppress=false;if(e.pointerType==='touch')swipe={x:e.clientX,y:e.clientY};});
    on(figure,'pointerup',e=>{if(!swipe)return;const dx=e.clientX-swipe.x,dy=e.clientY-swipe.y;swipe=null;if(Math.abs(dx)>35&&Math.abs(dx)>Math.abs(dy)){suppress=true;view=dx<0?'back':'front';render();}});
    on(figure,'pointercancel',()=>swipe=null);
    on(figure,'pointerleave',()=>figure.classList.remove('lens-active'));
    on(photo,'error',()=>q('[data-photo-error]').hidden=false);
    on(photo,'load',()=>q('[data-photo-error]').hidden=true);
    on(q('[data-purchase]'),'click',()=>dialog.showModal());
    qa('[data-close]').forEach(b=>on(b,'click',()=>b.closest('dialog').close()));
    qa('dialog').forEach(d=>on(d,'click',e=>{if(e.target!==d)return;const r=d.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)d.close();}));
    on(q('[data-guide-open]'),'click',()=>q('.guide-dialog').showModal());
    syncVariant(); syncSizeChoices(); render();
    clearInterval(this.flipTimer);
    let manualView = false;
    on(figure,'click',()=>manualView=true);
    on(figure,'keydown',()=>manualView=true);
    qa('[data-view],button[data-color]').forEach(b=>on(b,'click',()=>manualView=true));
    this.flipTimer=setInterval(()=>{
      if(manualView||matchMedia('(prefers-reduced-motion:reduce)').matches||document.hidden||!!q('dialog[open]')||this.matches(':hover,:focus-within'))return;
      if(view==='front'){view='back';render();}
      else {
        view='front';
        const nextColor=color==='black'?'white':'black';
        if(images[nextColor]?.front)setColor(nextColor);
        else render();
      }
    },3000);
  }
  disconnectedCallback(){this.abort?.abort();clearInterval(this.flipTimer);this.querySelectorAll('dialog[open]').forEach(d=>d.close());}
});

if (!customElements.get('prjct-drop')) customElements.define('prjct-drop',class extends HTMLElement {
 connectedCallback(){
  this.abort?.abort();this.abort=new AbortController();
  const on=(el,event,fn)=>el?.addEventListener(event,fn,{signal:this.abort.signal});
  const q=s=>this.querySelector(s), video=q('[data-background]'),toggle=q('[data-play]'),float=q('.motion-toggle'),hero=q('.dual-hero');
  const clock=q('[data-drop-clock]'),clockDigits=q('[data-drop-clock-digits]'),clockLabel=q('[data-drop-clock-label]');
  const motion=matchMedia('(prefers-reduced-motion:reduce)');let wanted=!motion.matches,floating=!motion.matches,visible=true,revision=0;
  const pad=n=>String(n).padStart(2,'0');
  let awaitingLaunch=clock && new Date(clock.dataset.dropAt).getTime()>Date.now();
  const tickClock=()=>{
   clearTimeout(this.clockTimer);
   if(!clock||!clockDigits)return;
   const target=new Date(clock.dataset.dropAt).getTime();
   if(!Number.isFinite(target)){clockDigits.textContent='--:--:--:--';return;}
   const ms=target-Date.now();
   const total=Math.max(0,Math.ceil(ms/1000));
   if(total<=0){
    clockDigits.textContent='00:00:00:00';
    if(clockLabel)clockLabel.textContent='LIVE';
    if(awaitingLaunch){awaitingLaunch=false;location.reload();}
    return;
   }
   const d=Math.floor(total/86400),h=Math.floor((total%86400)/3600),m=Math.floor((total%3600)/60),s=total%60;
   clockDigits.textContent=`${pad(d)}:${pad(h)}:${pad(m)}:${pad(s)}`;
   if(clockLabel)clockLabel.textContent='GAME CLOCK · DROP STARTS';
   this.clockTimer=setTimeout(tickClock,Math.min(1000-(Date.now()%1000)+20,ms+20));
  };
  const playbackUI=()=>{if(!video||!toggle)return;toggle.setAttribute('aria-pressed',String(!video.paused));toggle.textContent=video.paused?toggle.dataset.playLabel:toggle.dataset.pauseLabel;};
  const sync=()=>{
   const blocked=motion.matches||document.hidden||!visible||!!q('dialog[open]');
   hero.dataset.float=String(floating&&!blocked);
   if(float){float.textContent=floating?float.dataset.pauseLabel:float.dataset.playLabel;float.setAttribute('aria-pressed',String(floating));}
   if(!video)return;if(toggle)toggle.hidden=motion.matches;const current=++revision;
   if(blocked||!wanted){video.pause();playbackUI();return;}
   if(!video.getAttribute('src'))video.src=video.dataset.src;video.muted=true;
   video.play().then(()=>{if(current!==revision&&(motion.matches||document.hidden||!visible||q('dialog[open]')||!wanted))video.pause();playbackUI();}).catch(()=>{if(current===revision){wanted=false;playbackUI();}});
  };
  on(toggle,'click',()=>{wanted=!wanted;sync();});on(float,'click',()=>{floating=!floating;sync();});
  on(video,'play',playbackUI);on(video,'pause',playbackUI);on(video,'error',()=>{wanted=false;sync();});
  on(document,'visibilitychange',sync);on(motion,'change',()=>{wanted=floating=!motion.matches;sync();});
  this.dialogObserver=new MutationObserver(sync);this.dialogObserver.observe(this,{subtree:true,attributes:true,attributeFilter:['open']});
  if('IntersectionObserver'in window){this.visibilityObserver=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;sync();});this.visibilityObserver.observe(hero);}
  const audio=q('[data-music]'),musicToggle=q('[data-music-toggle]');
  if(audio&&musicToggle){
   let userMuted=false;
   audio.volume=0.35;
   const audioUI=()=>{const playing=!audio.paused&&!audio.muted;musicToggle.setAttribute('aria-pressed',String(playing));musicToggle.textContent=playing?musicToggle.dataset.muteLabel:musicToggle.dataset.playLabel;};
   const startAudio=()=>{if(userMuted||!audio.paused)return;audio.play().then(audioUI).catch(audioUI);};
   on(musicToggle,'click',()=>{if(!audio.paused){userMuted=true;audio.pause();}else{userMuted=false;startAudio();}audioUI();});
   on(document,'click',e=>{if(!musicToggle.contains(e.target))startAudio();});
   on(document,'keydown',e=>{if(!musicToggle.contains(e.target))startAudio();});
   on(audio,'play',audioUI);on(audio,'pause',audioUI);on(audio,'error',audioUI);
   startAudio();
  }
  sync();tickClock();
 }
 disconnectedCallback(){this.abort?.abort();clearTimeout(this.clockTimer);this.dialogObserver?.disconnect();this.visibilityObserver?.disconnect();this.querySelector('video')?.pause();this.querySelector('audio')?.pause();}
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prjct-halloween"] && !Shopify.designMode) return;
  try {
    
function initHalloween(scope){scope.querySelectorAll('.prjct-halloween:not([data-ready])').forEach(root=>{root.dataset.ready='true';const buy=root.querySelector('[data-ph-buy]'),purchase=root.querySelector('.ph-purchase'),close=root.querySelector('[data-ph-close]');if(buy&&purchase){buy.addEventListener('click',event=>{event.preventDefault();purchase.showModal()});close.addEventListener('click',()=>purchase.close());purchase.addEventListener('close',()=>buy.focus({preventScroll:true}));purchase.addEventListener('click',event=>{if(event.target!==purchase)return;const bounds=purchase.getBoundingClientRect();if(event.clientX<bounds.left||event.clientX>bounds.right||event.clientY<bounds.top||event.clientY>bounds.bottom)purchase.close()});root.querySelectorAll('[data-ph-size]').forEach(size=>size.addEventListener('change',()=>{root.querySelector('[data-ph-price]').textContent=size.dataset.price}));}root.querySelectorAll('[data-shirt-view]').forEach(control=>control.addEventListener('click',()=>{root.querySelector('.ph-product').dataset.view=control.dataset.shirtView;root.querySelectorAll('[data-shirt-view]').forEach(button=>button.setAttribute('aria-pressed',String(button===control)))}));if('IntersectionObserver' in window){const observer=new IntersectionObserver(entries=>root.classList.toggle('ph-offscreen',!entries[0].isIntersecting));observer.observe(root);}const button=root.querySelector('.ph-motion'),motion=matchMedia('(prefers-reduced-motion: reduce)');let paused=motion.matches;const sync=()=>{root.classList.toggle('ph-paused',paused||document.hidden);button.textContent=paused?button.dataset.play:button.dataset.pause;button.setAttribute('aria-pressed',String(paused))};button.addEventListener('click',()=>{paused=!paused;sync()});motion.addEventListener('change',e=>{paused=e.matches;sync()});document.addEventListener('visibilitychange',sync);const wrapper=root.closest('.shopify-section'),next=wrapper?.nextElementSibling;if(next)next.id='prjct-001';sync()})}initHalloween(document);document.addEventListener('shopify:section:load',e=>initHalloween(e.target));

  } catch(e) { console.error(e); }
})();
})();
